import { useDispatch } from "react-redux";
import { ActivityGrid } from "./ActivityGrid";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { setPageTitle } from "../../../store/slices/pageTitleSlice";

export const Activity = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setPageTitle("Activity: Patient Profile | Spire360"));
  }, []);

  return <ActivityGrid patientId={patientId} />;
};
